import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index'
import About from '../views/About'
import Service from '../views/Service'
import Pricing from '../views/Pricing'
import Member from '../views/Member'
import Partner from '../views/Partner'
import TopicDetail from '../views/TopicDetail'
import NewsDetail from '../views/NewsDetail.vue'
import ErrorPage from '../views/404'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/index',
        meta: {
            noCache: true
        }
    },
    {
        path: '/index',
        name: 'Index',
        component: Index,
        meta: {
            title: 'iSafeClub',
        },
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: 'iSafeClub',
        },
    },
    {
        path: '/service',
        name: 'Service',
        component: Service,
        meta: {
            title: 'iSafeClub',
        },
    },
    {
        path: '/pricing',
        name: 'Pricing',
        component: Pricing,
        meta: {
            title: 'iSafeClub',
        },
    },
    {
        path: '/member',
        name: 'Member',
        component: Member,
        meta: {
            title: 'iSafeClub',
        },
    },
    {
        path: '/partner',
        name: 'Partner',
        component: Partner,
        meta: {
            title: 'iSafeClub',
        },
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: NewsDetail,
        meta: {
            title: 'iSafeClub',
        },
    },
    {
        path: '/topics/:id',
        name: 'TopicDetail',
        component: TopicDetail,
        meta: {
            title: 'iSafeClub',
        },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'Error',
        component: ErrorPage,
        meta: {
            title: 'iSafeClub',
        },
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
    window.scrollTo(0, 0)
});

export default router
